const regexUUID = /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/;

export const isUUID = (value: string): boolean => regexUUID.test(value);
